const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");
const _ = require("lodash");

const AT = require("../core/vault/ActionTypes");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const AssetsUtil = require("../core/util/AssetsUtil");
const InfoIcon = require("../office/InfoIcon");
const Dropdown = require("./SchoolDropdown");

const {atSchoolRosters} = require("../core/vault/StateCursors");

const styles = require("./styles/GenerateRoster.css");

const getPropsFromVault = function(props, vaultState) {
	const rosters = atSchoolRosters(vaultState).get();
	const url = _.get(rosters, ["model", props.name, "url"], null);

	return {
		url,
	};
};

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "GenerateRoster",

		propTypes: {
			for: PT.string.isRequired,
			name: PT.string.isRequired,
			continue: PT.func.isRequired,
			roster: PT.object.isRequired,
			currentYear: PT.number.isRequired,
			schoolState: PT.object.isRequired,

			url: PT.string,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		getInitialState: function() {
			return {
				yearFilter: "currentYear",
			};
		},

		componentDidUpdate: function(prevProps, prevState) {
			if (prevProps.name !== this.props.name) {
				this.props.dispatch({
					type: AT.ROSTERING_GENERATE_CSVS_RESET,
				});
			}

			const rosterModel = _.get(this.props.roster, "model", {});
			const prevRosterModel = _.get(prevProps.roster, "model", {});
			if (
				!prevRosterModel[this.props.name] &&
				rosterModel[this.props.name] &&
				rosterModel[this.props.name].generated
			) {
				if (this.link) {
					this.link.click();
				}
			}
		},

		onContinue: function() {
			this.props.continue();
		},

		isRosterPresent: function() {
			return (
				_.get(this.props.roster, ["model", this.props.name], null) !== null
			);
		},

		isRosterGenerated: function() {
			const rosters = _.get(this.props.roster, "model", {});
			return rosters[this.props.name] && rosters[this.props.name].generated;
		},

		generateCSV: function() {
			const currentYear = _.get(this.props.schoolState, [
				"accounts",
				"purchase",
				"currentYear",
			]);
			let year;
			if (this.state.yearFilter === "previousYear") {
				year = currentYear - 1;
			} else {
				year =
					this.state.yearFilter === "currentYear"
						? currentYear
						: currentYear + 1;
			}
			this.props.dispatch({
				type: AT.ROSTERING_GENERATE_CSVS_REQUEST,
				purchaseID: _.get(this.props.schoolState, [
					"accounts",
					"purchase",
					"id",
				]),
				which: this.props.for,
				year: year,
			});
		},

		makeGenerate: function() {
			return (
				<div className={styles.download} onClick={this.generateCSV}>
					<div className={styles.downloadImage}>
						<img src={AssetsUtil.getTrainerIconButton("download")} />
					</div>
					<div className={styles.downloadText}>
						{`Download ${_.capitalize(this.props.for)} Roster`}
					</div>
				</div>
			);
		},

		getYearSelectOptions: function() {
			const {currentYear} = this.props;
			return {
				previousYear: `${currentYear - 2}-${currentYear - 1}`,
				currentYear: `${currentYear - 1}-${currentYear}`,
				nextYear: `${currentYear}-${currentYear + 1}`,
			};
		},

		updateYearFilter: function(val) {
			this.setState({
				yearFilter: val,
			});
			this.props.dispatch({
				type: AT.ROSTERING_GENERATE_CSVS_RESET,
			});
		},

		getInfoIconText: function() {
			const {currentYear} = this.props;
			return (
				<div className={styles.infoIconText}>
					<p className={styles.infoIconTextPiece}>
						{`If you want to download your rosters for the previous academic year, choose ${currentYear -
							2}-${currentYear - 1}.`}
					</p>
					<p className={styles.infoIconTextPiece}>
						{`If you are updating your rosters for the current academic year, choose ${currentYear -
							1}-${currentYear}.`}
					</p>
					<p className={styles.infoIconTextPiece}>
						{`If you are planning ahead and creating your rosters for the next academic year, choose ${currentYear}-${currentYear +
							1}.`}
					</p>
				</div>
			);
		},

		makeYearSelect: function() {
			return (
				<Dropdown
					className={styles.years}
					options={this.getYearSelectOptions()}
					initialValue={"currentYear"}
					updateSelection={this.updateYearFilter}
					style={"rectangle"}
				/>
			);
		},

		makeDownload: function() {
			const filter = this.state.yearFilter;
			const csvName = `ba-${this.getYearSelectOptions()[filter]}-${
				this.props.for
			}.csv`;
			return (
				<a
					className={styles.downloadLink}
					href={this.props.url}
					download={csvName}
					ref={a => (this.link = a)}
				>
					<div className={styles.download}>
						<div className={styles.downloadImage}>
							<img src={AssetsUtil.getTrainerIconButton("download")} />
						</div>
						<div className={styles.downloadText}>{`Download ${_.capitalize(
							this.props.for
						)} Roster`}</div>
					</div>
				</a>
			);
		},

		makeGenerateOrDownload: function() {
			let innerDiv = null;
			if (this.isRosterPresent() && this.isRosterGenerated()) {
				innerDiv = this.makeDownload();
			} else {
				innerDiv = this.makeGenerate();
			}

			return <div className={styles.generateOrDownload}>{innerDiv}</div>;
		},

		render: function() {
			return (
				<div className={styles.main}>
					<div className={styles.yearSelect}>
						<div className={styles.infoIcon}>
							<InfoIcon
								title={"Year"}
								text={this.getInfoIconText()}
								isModal={true}
								className={styles.info}
							/>
						</div>
						<div className={styles.infoIconLabel}>Year:</div>
						<div className={styles.yearSelectDropdown}>
							{this.makeYearSelect()}
						</div>
					</div>
					{this.makeGenerateOrDownload()}
					<div className={styles.button} onClick={this.onContinue}>
						{"Continue"}
					</div>
				</div>
			);
		},
	})
);
